export default "https://cdn-static.gokick.com/assets/b4422e726e3b42ca3d48f0d34192932f5b3fbcfa/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";